<template>
  <div class="create">

    <v-container>

      <v-row class="headline">Start a new story</v-row>
      <v-form ref="createform" v-model="formvalid">
        <v-text-field
            v-model="title"
            outlined
            clearable
            label="Story Title"
            type="text"
            :rules="titleRules"
            id="title"
          >
        </v-text-field>
        <v-checkbox
          v-model="subscribeToStory"
          label="Subscribe to updates for this story"
        ></v-checkbox>
        <v-checkbox
          v-model="emailDetails"
          label="Email you links to the story. You should do this so you don't lose the story links! We'll only send one email."
        ></v-checkbox>
        <v-text-field
            v-model="emailAddress"
            v-if="emailDetails || subscribeToStory"
            outlined
            clearable
            label="Email address"
            type="text"
            :rules="emailRules"
            id="title"
          >
        </v-text-field>
        <v-row>

        </v-row>
        <v-row>
          <v-spacer></v-spacer>

          <vue-recaptcha
              ref="invisibleRecaptcha"
              size="invisible"
              :sitekey="sitekey"
              @verify="onVerify"
              @expired="onExpired"
              >
              <v-btn text color="light-blue" :disabled="!formvalid" :loading="loading">
                Start the Story<v-icon size="50" >{{ mdiArrowRight }}</v-icon>
              </v-btn>

          </vue-recaptcha>

        </v-row>

        <h2 v-if="errtext" class="red--text">{{errtext}}</h2>
      </v-form>
    </v-container>

  </div>
</template>

<script>
// @ is an alias to /src
import config from '../config.js'
import { mdiArrowRightCircleOutline } from '@mdi/js'
import utils from '../utils.js'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'CreateStory',
  components: {
    VueRecaptcha
  },
  data () {
    return {
      sitekey: config.recaptchaSiteKey,
      mdiArrowRight: mdiArrowRightCircleOutline,
      title: '',
      loading: false,
      errtext: null,
      emailDetails: true,
      subscribeToStory: false,
      emailAddress: null,
      formvalid: false,
      titleRules: [
        v => !!v || 'A title is required',
        v => v.length <= 80 || 'Title must be less than 80 characters'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ]
    }
  },
  methods: {
    startStory: function (recaptchaToken) {
      // Call a function to create the story with the title and password.
      console.log('startTheStory')
      this.errtext = null
      const dynFunction = config.getFunctions().httpsCallable('dynFunction')

      this.loading = true
      dynFunction({
        call: 'startStory',
        title: this.title,
        email: this.emailAddress,
        subscribe: this.subscribeToStory,
        emailDetails: this.emailDetails,
        recaptchaToken: recaptchaToken
      })
        .then((rc) => {
        // Get the password and storyID from the function
          const password = rc.data.password
          const storyID = rc.data.storyID
          utils.addStoryPassword(this.$cookies, password)

          // Now navigate to readd the story
          this.$router.push({ path: 'story/' + storyID })
          this.loading = false

          if (this.$gtag) {
            this.$gtag.event('createStory', { method: 'Natural' })
          }
        }).catch((err) => {
          console.error('Error startStory: ' + err)
          this.errtext = err
          this.loading = false
          this.resetRecaptcha()
        })
    },
    onVerify: function (response) {
      // Recaptcha Verify
      // console.log('Verify: ' + response)

      // Call to the server to verify and respond.
      this.startStory(response)
    },
    onExpired: function () {
      // Recaptcha expired
      console.log('Expired')
    },
    resetRecaptcha () {
      this.$refs.invisibleRecaptcha.reset() // Direct call reset method
    }

  }

}
</script>
<style>
.grecaptcha-badge {
    bottom:40px !important;
}
</style>
